export default __webpack_public_path__ + "static/media/17.c374e26b.svg";